export const USER_SEASON_ERROR_MESSAGES = {
  // Validation Erros
  INVALID_SEASON_ID: 'Invalid season ID provided',
  INVALID_DATA: 'Invalid user season fighter data provided',

  SERVER_ERROR: 'Server error occurred',
} as const;
